import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import CustomTabs from "../controls/Tabs";
import TabContainer from "../controls/TabContainer";
import ProductTab from "./ProductTab";
import ProductTypeTab from "./ProductTypeTab";
import Container from "../controls/Container";
import Button from "material-ui/Button";
import Searchbox from "../controls/Searchbox";

const styles = theme => ({
  root: {
    padding: 10
  },
  tabHolder: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  tab: {
    boxShadow: "none"
  },
  tabItem: {
    fontSize: "12px"
  },
  indicator: {
    backgroundColor: "#3f51b5"
  },
  button: {
    margin: theme.spacing.unit
  },
  wrapper: {
    position: "relative",
    margin: "20px 5px 5px 5px"
  }
});

class Products extends Component {
  state = {
    clearSearch: false,
    value: 0
  };

  componentDidMount() {
    if (this.props.history.location.pathname === "/products") {
      this.setState({ value: 0 });
    } else {
      this.setState({ value: 1 });
    }
  }

  handleChange = (event, value) => {
    if (value === 0) {
      this.props.history.push("/products");
    } else {
      this.props.history.push("/producttypes");
    }
    this.setState({ value });
  };

  render() {
    const { classes } = this.props;
    const { 
      clearSearch,value } = this.state;

    return (
      <div>
        <div className={classes.tabHolder}>
          {/* <CustomTabs
            onChange={this.handleChange}
            value={value}
            items={["Products", "Product Types"]}
          />
          {value === 0 && (
            <TabContainer>
              <ProductTab />
            </TabContainer>
          )}
          {value === 1 && (
            <TabContainer>
              <ProductTypeTab />
            </TabContainer>
          )} */}
      <Container title="Categories">
        
      <div>
          <Button
            className={classes.button}
            variant="raised"
            color="default"
            size="small"
            onClick={this.onListClick}
          >
            List
          </Button>

          <Button
            className={classes.button}
            variant="raised"
            color="primary"
            size="small"
            onClick={this.onCreateNewClick}
          >
            Create New
          </Button>

          <Searchbox
            clear={clearSearch}
            onChange={this.onSearchChange}
            onSubmit={this.onSearchSubmit}
          />
        </div>
        <div className={classes.wrapper}>
          <table className="customtable">
            <thead className="customthead">
            <tr className="customtr">
              <th>Category</th>
              <th>Monthly Charges (RM)</th>
            </tr>
            </thead>
            <tr className="customtr">
              <td class="customtdleft">Low cost houses and government quarters in categories F, G, H and I ( receiving either Individual Septic Tank or Connected Sewerage Services )</td>
              <td>2.00</td>
            </tr>
            <tr className="customtr">
              <td class="customtdleft">Houses in Kampung, New Villages and Estates (receiving either Individual Septic Tank or Connected Sewerage Services )	</td>
              <td>3.00</td>
            </tr>
            <tr className="customtr">
              <td class="customtdleft">Premises and government quarters in categories A, B, C, D and E receiving Individual Septic Tank Services	</td>
              <td>6.00</td>
            </tr>
            <tr className="customtr">
              <td class="customtdleft">Premises and government quarters in categories A, B, C, D, and E receiving Connected Sewerage Services	</td>
              <td>8.00</td>
            </tr>
          </table>
        </div>
      </Container>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Products));



// WEBPACK FOOTER //
// ./src/components/products/Products.js